// extracted by mini-css-extract-plugin
module.exports = {"userInput":"UserInput_userInput__QJDwD","mt-4":"UserInput_mt-4__N7TAs"};